import React from 'react';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { JobManagementTabs } from '@/features/jobs/JobManagementTabs';

export function JobManagementPage() {
  return (
    <DashboardLayout>
      <JobManagementTabs />
    </DashboardLayout>
  );
}
